import React, { useState, useEffect } from "react";
import NavBar from "./NavBar.js";
import BlackButton from "./BlackButton.js";
import { FaBars, FaTimes } from "react-icons/fa";
// import { Link } from "react-scroll";
import { Link } from "react-router-dom";
import IconLabel from "./IconLabel.js";
import { MailIcon, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";

const links = [
  { href: "/offerings", text: "Offerings" },
  { href: "/case-studies", text: "Case Studies" },
  { href: "/about", text: "About Us" },
  { href: "/careers", text: "Careers" },
];

const mobileLinks = [
  { href: "/offerings", text: "Offerings" },
  { href: "/case-studies", text: "Case Studies" },
  { href: "/about", text: "About Us" },
  { href: "/careers", text: "Careers" },
  { href: "/contact", text: "Contact Us" },
];

const Header = ({ className = "md:px-20 md:mt-4" }) => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [isMenuOpen]);

  return (
    <header
      className={`flex justify-between items-center py-2.5 md:py-8 px-3.5 relative ${className}`}
    >
      {/* Logo */}
      <a href="/">
        <img
          className="h-[32px] md:h-[46px]"
          src="/datapixl-logo.png"
          alt="DataPixl"
        ></img>
      </a>

      {/* Desktop Navigation - Centered */}
      <div className="hidden md:block flex-grow justify-center absolute left-1/2 -translate-x-1/2">
        <NavBar links={links} />
      </div>

      {/* Desktop Button - Right */}
      <div className="hidden md:block flex-shrink-0">
        <BlackButton text="Contact Us" onClick={() => navigate("/contact")} />
      </div>

      {/* Mobile Menu Button - pinned to the header's top-of-viewport spot while open,
          so content above the header (e.g. an announcement banner) can't push it down */}
      <button
        className={`md:hidden p-2 z-50 ${
          isMenuOpen ? "fixed top-2.5 right-3.5" : ""
        }`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        {isMenuOpen ? (
          <FaTimes className="w-6 h-6" />
        ) : (
          <FaBars className="w-6 h-6" />
        )}
      </button>

      {/* Animated Mobile Menu (Sliding from Top) */}
      <div
        className={`flex flex-col fixed top-0 left-0 w-full h-full bg-app-background z-40 transform transition-transform duration-300 ease-in-out ${
          isMenuOpen
            ? "translate-y-0 opacity-100"
            : "-translate-y-full opacity-100" // Keep opacity at 100 during close transition
        } md:hidden`}
      >
        {/* Navigation Links */}
        <nav className="flex flex-col items-start justify-center px-6 py-10 gap-6 text-white text-2xl">
          {mobileLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              smooth
              className="hover:text-gray-400 transition-colors font-semibold"
              onClick={() => setIsMenuOpen(false)}
            >
              {link.text}
            </Link>
          ))}
        </nav>
        <div className="flex-grow"></div>
        <div className="p-6 pb-14 space-y-2">
          <IconLabel icon={<MailIcon size={18} />} label="contact@datapixl" />
          <IconLabel icon={<Phone size={18} />} label="+91 9353636917" />
        </div>
      </div>
    </header>
  );
};

export default Header;
